module.exports = __webpack_public_path__ + "img/bs_banner_tr.6241abb5.jpg";